import 'react-slidedown/lib/slidedown.css';

import * as React from 'react';
import classnames from 'classnames';

const SlideDown = require('react-slidedown').SlideDown;

export interface Props {
    venueNotes: string;
    isShown?: boolean;
}
export interface State {
    isShown: boolean;
}
const createMarkup = (markup: string) => ({ __html: markup.replace(/\n/g, '<br />') });

export default class ServiceOptions extends React.Component<Props, State> {
    constructor(props: Props) {
        super(props);
        this.handleToggleClick = this.handleToggleClick.bind(this);
        this.state = {
            isShown: !!props.isShown,
        };
    }

    public render() {
        return (
            <div className='VenuePage--detail VenuePage--detail__expandable'>
                <div className='VenuePage--detail-headline-container' onClick={this.handleToggleClick}>
                    <h3 className='VenuePage--detail-headline VenuePage--detail-headline__expandable'>
                        Venue notes
                        <i
                            className={classnames('icon-hb-nx-arrow-down-16', { 'icon-hb-nx-arrow-down-16__flipped': this.state.isShown })}
                        />
                    </h3>
                </div>

                <div className='VenuePage--additional-detail-container'>
                    <SlideDown className={'VenuePage--row'}>
                        {this.state.isShown && (
                            <p className='VenuePage--additional-detail ' dangerouslySetInnerHTML={createMarkup(this.props.venueNotes)} />
                        )}
                    </SlideDown>
                </div>
            </div>
        );
    }

    private handleToggleClick(e: React.SyntheticEvent<HTMLElement>) {
        this.setState({ isShown: !this.state.isShown });
    }
}
